import { render, staticRenderFns } from "./ArtistRegister.vue?vue&type=template&id=29fb97d3&scoped=true"
import script from "./ArtistRegister.vue?vue&type=script&lang=js"
export * from "./ArtistRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb97d3",
  null
  
)

export default component.exports